/* The values every GRYD component reads: the four font tokens, the ink border, and the
   style objects the system publishes for hand-rolled controls. Tokens only, never a literal. */

export const BODY = 'var(--font-body)';
export const MONO = 'var(--font-mono)';
export const DISPLAY = 'var(--font-display)';
export const TITLE = 'var(--font-title)';

/** The ink border: 2px unless a width is given (1.5 for small parts, 1 for hairlines). */
export const ink = (w) => `${w || 2}px solid var(--ink)`;

/** The style of the one text field, for controls built by hand. */
export const inputS = { width: '100%', boxSizing: 'border-box', padding: '9px 13px', fontFamily: BODY, fontSize: 13.5, fontWeight: 600, color: 'var(--tx)', background: 'var(--input)', border: ink(2), borderRadius: 10, outline: 'none' };
export const inputCompactS = { ...inputS, padding: '6px 10px', fontSize: 12.5, borderRadius: 8 };
/** Props that keep a secret out of autofill and spellcheck. */
export const secretInputProps = { type: 'text', autoComplete: 'off', spellCheck: false, 'data-lpignore': 'true' };
/** Masks a secret with discs while keeping it selectable. */
export const secretMaskS = { fontFamily: MONO, WebkitTextSecurity: 'disc' };

/** The drawn card as a style object, for surfaces that cannot be a <Card>. */
export const cardS = { background: 'var(--card)', border: ink(2), borderRadius: 'var(--r-card)', boxShadow: 'var(--el-3)', padding: 'var(--card-pad)' };
